import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { defaultValueCtx, Editor as MilkdownEditor, editorViewOptionsCtx, rootCtx, } from '@milkdown/core';
import { Milkdown, useEditor } from '@milkdown/react';
import { commonmark } from '@milkdown/preset-commonmark';
import { listener, listenerCtx } from '@milkdown/plugin-listener';
import { history } from '@milkdown/plugin-history';
import { clipboard } from '@milkdown/plugin-clipboard';
import { useNotesToolbarContext } from '../../context/notes/notes_toolbar_context';
import { useEditorStateContext } from '../../context/notes/notes_editor_state_context';
import { sanitizeMarkdown } from './config';
import { listPlugin, linkPlugin } from './plugins';
import { useSetInitialFocus } from '../../hooks/notes/use_set_initial_focus';
export function Editor({ defaultValue }) {
    const { onSelectionUpdated } = useNotesToolbarContext();
    const { handleMarkdownUpdated, readOnlyYn, displayModeYn } = useEditorStateContext();
    const isEditableYn = !displayModeYn && !readOnlyYn;
    const { get } = useEditor(root => {
        return MilkdownEditor.make()
            .config(ctx => {
            ctx.set(rootCtx, root);
            ctx.set(defaultValueCtx, sanitizeMarkdown(defaultValue));
            ctx.get(listenerCtx).selectionUpdated((ctx, selection) => {
                onSelectionUpdated(ctx, selection);
            });
            ctx.get(listenerCtx).markdownUpdated((_, updatedMarkdown) => {
                handleMarkdownUpdated(updatedMarkdown);
            });
            ctx.update(editorViewOptionsCtx, prev => ({
                ...prev,
                editable: () => isEditableYn,
            }));
        })
            .use(commonmark)
            .use(linkPlugin)
            .use(listPlugin)
            .use(history)
            .use(listener)
            .use(clipboard);
    }, [isEditableYn]);
    useSetInitialFocus(get, isEditableYn);
    return _jsx(Milkdown, {});
}
//# sourceMappingURL=editor.js.map